/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordResetChallengeOptions } from './PasswordResetChallengeOptions';
import {
    PasswordResetChallengeOptionsFromJSON,
    PasswordResetChallengeOptionsFromJSONTyped,
    PasswordResetChallengeOptionsToJSON,
} from './PasswordResetChallengeOptions';

/**
 * 
 * @export
 * @interface PasswordResetChallengeAllOf
 */
export interface PasswordResetChallengeAllOf {
    /**
     * 
     * @type {PasswordResetChallengeOptions}
     * @memberof PasswordResetChallengeAllOf
     */
    options: PasswordResetChallengeOptions;
}

/**
 * Check if a given object implements the PasswordResetChallengeAllOf interface.
 */
export function instanceOfPasswordResetChallengeAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function PasswordResetChallengeAllOfFromJSON(json: any): PasswordResetChallengeAllOf {
    return PasswordResetChallengeAllOfFromJSONTyped(json, false);
}

export function PasswordResetChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': PasswordResetChallengeOptionsFromJSON(json['options']),
    };
}

export function PasswordResetChallengeAllOfToJSON(value?: PasswordResetChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': PasswordResetChallengeOptionsToJSON(value.options),
    };
}

